/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credit: NonNullable<unknown> }} Partner_Faq_Credit_AInputs */



/**
* | output |
* | --- |
* | "Every billed Team seat includes {credit} of AI usage per month. Usage within the credit is free. Only usage above it appears on the bill, as AI usage. The re..." |
*
* @param {Partner_Faq_Credit_AInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_credit_a = /** @type {((inputs: Partner_Faq_Credit_AInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Credit_AInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Jeder abgerechnete Team-Platz enthält ${i?.credit} KI-Nutzung pro Monat. Nutzung innerhalb des Guthabens ist kostenlos. Nur die Nutzung darüber erscheint in der Abrechnung, als KI-Nutzung. Der Beleg zeigt, wie viel enthalten war und wie viel genutzt wurde.`)
	return /** @type {LocalizedString} */ (`Every billed Team seat includes ${i?.credit} of AI usage per month. Usage within the credit is free. Only usage above it appears on the bill, as AI usage. The receipt shows how much was included and how much was used.`)
});